import {Serializer} from "../interfaces/serializer";
import {Notification} from "../interfaces/notification";

export class NotificationComponentObject {
  public payload: Serializer<Notification>;

  constructor(notification: Serializer<Notification>) {
    this.payload = notification;
  }
}
